module.exports = __webpack_public_path__ + "assets/img/edgeprop-logo.0f6174dc.png";